import React from "react";
import "../../../../assets/scss/components/ui/drawner/vehicle/AvailableVehicles.scss"

const Pagination = ({ theme, currentPage, totalPages, onPageChange }) => (
  <div className={`GM__${theme}-pagination`}>
    <button
      onClick={() => onPageChange(currentPage - 1)}
      disabled={currentPage === 1}
      className={`GM__${theme}-pagination-btn`}
    >
      &lt;
    </button>
    <span className={`GM__${theme}-pagination-info`}>
      Página {currentPage} de {totalPages}
    </span>
    <button
      onClick={() => onPageChange(currentPage + 1)}
      disabled={currentPage === totalPages}
      className={`GM__${theme}-pagination-btn`}
    >
      &gt;
    </button>
  </div>
);

// Lista de vehículos disponibles
const RegularVehiclesList = ({
  theme,
  vehicles,
  selectedVehicles,
  totalPages,
  currentPage,
  onPageChange,
  onSelectVehicle,
}) => {
  if (vehicles.length === 0) return null;

  return (
    <div className={`GM__${theme}-vehicles-section`}>
      <div className={`GM__${theme}-section-title`}>
        Vehículos Disponibles
      </div>
      <div className={`GM__${theme}-vehicles-list-header`}>
        <div className={`GM__${theme}-vehicle-select-header`}></div>
        <div className={`GM__${theme}-vehicle-plate-header`}>Placa</div>
        <div className={`GM__${theme}-vehicle-type-header`}>Tipo</div>
      </div>

      {vehicles.map((vehicle) => {
        const isSelected = selectedVehicles.includes(vehicle.id);
        return (
          <div
            key={vehicle.id}
            className={`GM__${theme}-available-vehicle-item ${
              isSelected ? "selected" : ""
            }`}
            onClick={() => onSelectVehicle(vehicle.id)}
          >
            <div className={`GM__${theme}-vehicle-checkbox`}>
              <input
                type="checkbox"
                checked={isSelected}
                onChange={() => {}} // El cambio se maneja en el onClick del div padre
                onClick={(e) => e.stopPropagation()}
              />
            </div>
            <div className={`GM__${theme}-vehicle-plate`}>
              {vehicle.plate || "N/A"}
            </div>
            <div className={`GM__${theme}-vehicle-type`}>
              {vehicle.vehicle_type_name || "N/A"}
            </div>
          </div>
        );
      })}

      {/* Paginación */}
      {totalPages > 1 && (
        <Pagination 
          theme={theme}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange}
        />
      )}
    </div>
  );
};

// Lista de combinaciones disponibles
const CombinedVehiclesList = ({
  theme,
  combinedVehicles,
  selectedVehicles,
  totalPages,
  currentPage,
  onPageChange,
  onSelectVehicle,
}) => {
  if (combinedVehicles.length === 0) return null;

  return (
    <div className={`GM__${theme}-combined-section`}>
      <div className={`GM__${theme}-section-title`}>
        Combinaciones Disponibles
      </div>
      <div className={`GM__${theme}-vehicles-list-header`}>
        <div className={`GM__${theme}-vehicle-select-header`}></div>
        <div className={`GM__${theme}-vehicle-plate-header`}>Cabezote</div>
        <div className={`GM__${theme}-vehicle-plate-header`}>Remolque</div>
      </div>

      {combinedVehicles.map((combo) => {
        const isSelected = selectedVehicles.includes(combo.vehicle.id);
        return (
          <div
            key={combo.id}
            className={`GM__${theme}-available-vehicle-item combined ${
              isSelected ? "selected" : ""
            }`}
            onClick={() => onSelectVehicle(combo.vehicle.id)}
          >
            <div className={`GM__${theme}-vehicle-checkbox`}>
              <input
                type="checkbox"
                checked={isSelected}
                onChange={() => {}} // El cambio se maneja en el onClick del div padre
                onClick={(e) => e.stopPropagation()}
              />
            </div>
            <div className={`GM__${theme}-vehicle-plate`}>
              {combo.vehicle?.plate || "N/A"}
            </div>
            <div className={`GM__${theme}-vehicle-plate`}>
              {combo.trailer?.plate || "N/A"}
            </div>
          </div>
        );
      })}

      {/* Paginación */}
      {totalPages > 1 && (
        <Pagination 
          theme={theme}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange}
        />
      )}
    </div>
  );
};

const AvailableVehicles = ({
  theme,
  vehicleType,
  availableVehicles,
  availableCombinedVehicles,
  selectedVehicles,
  availableTotalPages,
  currentPage,
  searchTerm,
  onPageChange,
  onSelectVehicle
}) => {
  const hasRegularVehicles = (vehicleType === "all" || vehicleType === "vehicles") &&
    availableVehicles.length > 0;
  
  const hasCombinedVehicles = (vehicleType === "all" || vehicleType === "combined") &&
    availableCombinedVehicles.length > 0;
  
  const noVehicles = !hasRegularVehicles && !hasCombinedVehicles;

  return (
    <div className={`GM__${theme}-available-vehicles-list`}>
      {/* Vehículos regulares disponibles */}
      {hasRegularVehicles && (
        <RegularVehiclesList 
          theme={theme}
          vehicles={availableVehicles}
          selectedVehicles={selectedVehicles}
          totalPages={availableTotalPages}
          currentPage={currentPage}
          onPageChange={onPageChange}
          onSelectVehicle={onSelectVehicle}
        />
      )}

      {/* Vehículos combinados disponibles */}
      {hasCombinedVehicles && (
        <CombinedVehiclesList 
          theme={theme}
          combinedVehicles={availableCombinedVehicles}
          selectedVehicles={selectedVehicles}
          totalPages={availableTotalPages}
          currentPage={currentPage}
          onPageChange={onPageChange}
          onSelectVehicle={onSelectVehicle}
        />
      )}

      {/* Mensaje cuando no hay vehículos disponibles */}
      {noVehicles && (
        <div className={`GM__${theme}-empty-message`}>
          {searchTerm
            ? `No se encontraron vehículos para "${searchTerm}"`
            : "No hay vehículos disponibles"}
        </div>
      )}
    </div>
  );
};

export default React.memo(AvailableVehicles);